import { ApiError } from "@/shared/types/error";

export function isApiError(error: unknown): error is ApiError {
    return typeof (error as ApiError)?.status === "number";
}

export function handleNotFoundAsEmpty<T>(error: unknown): T[] {
    if (isApiError(error) && error.status === 404) {
        return [];
    }
    throw error;
}

/**
 * Format an error message for display
 * Handles API errors with status codes and generic errors
 */
export function formatErrorMessage(error: Error): string {
    const message = error.message || "Er is een onbekende fout opgetreden";
    const formattedMessage = message.endsWith(".") ? message : `${message}.`;

    if (isApiError(error)) {
        return `API Error (${error.status}): ${formattedMessage}`;
    }

    return error.name && error.name !== "Error" ? `${error.name}: ${formattedMessage}` : formattedMessage;
}

export function normalizeError(error: unknown): Error {
    if (error instanceof Error) return error;
    if (typeof error === "string") return new Error(error);
    return new Error("Er is een onbekende fout opgetreden");
}
